// Action Types
import {
        GET_COUNTRY_SUCCESS, GET_CUSTOMERS_SUCCESS, GET_CUSTOMER_TRANSACTIONS_SUCCESS, GET_CUSTOMER_PAYMENTS_SUCCESS, ADD_COUNTRY_SUCCESS
        } from '../actions/actionTypes';

// Utils
import { getNewState } from '../shared/utils/frontend';

// Initial State
const initialState = {
  customers: []
};

export default function customersReducer(state = initialState, action) {
  switch (action.type) {
    
    /*
    case GET_COUNTRY_SUCCESS:
    {
      const {payload: country} = action;
      console.log('ACTION');
      console.log(action);
      return getNewState(state, {
        country
      });
    }
    break;
    */

    case GET_CUSTOMERS_SUCCESS:
    {
      const {payload: result} = action;
      console.log('ACTION');
      console.log(action);
      return getNewState(state, {
        result
      });
    }
    break;

    case GET_CUSTOMER_TRANSACTIONS_SUCCESS:
    {
      const {payload: result} = action;
      console.log('ACTION');
      console.log(action);
      return getNewState(state, {
        result
      });
    }
    break;

    case GET_CUSTOMER_PAYMENTS_SUCCESS:
    {
      const {payload: result} = action;
      console.log('ACTION');
      console.log(action);
      return getNewState(state, {
        result
      });
    }
    break;
    
    /*
    case ADD_COUNTRY_SUCCESS:
    {
      const {payload: customers} = action;
      return getNewState(state, {
        customers
      });
    }
    break;
    */
    
  default:
      return state;
}
};